// パートナー様の声 スライダー
jQuery(function ($) {
	$(".voice__slider").slick({
		autoplay: true,
		dots: true,
		infinite: true,
		prevArrow: '<button type="button" class="slick-prev"><span></span></button>',
		nextArrow: '<button type="button" class="slick-next"><span></span></button>',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: "8.5%",
				},
			},
		],
	});
});
